import axios from 'axios';

export default {
  getUserToken () { // 토큰(헤더)으로 로그인
    return new Promise((resolve, reject) => {
      axios.get(`/v2/user/token`).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postUserSign (fields) { // 가입 또는 로그인
    return new Promise((resolve, reject) => {
      axios.post(`/v2/user/sign`, fields).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getUserEmail (email) { // 이메일 주소 가입 여부 확인
    return new Promise((resolve, reject) => {
      axios.get(`/v2/user/email/${email}`).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  patchUserProfileImage (form) { // 프로필 이미지 수정
    return new Promise((resolve, reject) => {
      axios.patch(`/v3/user/image`, form).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  patchUser (fields) { // 유저 정보 수정
    return new Promise((resolve, reject) => {
      axios.patch(`/v3/user`, fields).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getUserCount (second) {
    return new Promise((resolve, reject) => {
      axios.get(`/v3/user/count`, {
        params: {
          time: second,
        }
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getUserAddress () {
    return new Promise((resolve, reject) => {
      axios.get(`/v3/user/address`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getPostUserIdxBookmark (second, userIdx, page) { // 유저 북마크 글 조회
    return new Promise((resolve, reject) => {
      axios.get(`/v5/post/user/${userIdx}/bookmark`, {
        params: {
          time: second,
          page,
          count: 10,
        }
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getStoreUserIdxBookmark (second, userIdx, page) { // 유저 찜 상품 조회
    return new Promise((resolve, reject) => {
      axios.get(`/v2/store/user/${userIdx}/bookmark`, {
        params: {
          time: second,
          page,
          count: 20,
        }
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getUserSignout () { // Cloudfront 쿠키 삭제 (동영상 재생시 동시접속 방지)
    return new Promise((resolve, reject) => {
      axios.get(`/v2/user/signout`).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  // 배송지 관련
  getDeliveryInfo () {
    return new Promise((resolve, reject) => {
      axios.get(`/v3/delivery/info`, { params: {
        page: 1,
        count: 1, // 가장 최신 배송지 1개만 가져옴. 나중에 필요할 시 리팩토링 하세요
      }}).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postDeliveryInfo (name, email, phone, zipcode, address, detailAddress) { // 새로운 배송지 등록
    return new Promise((resolve, reject) => {
      axios.post(`/v3/delivery/info`, {
        name,
        email,
        phone,
        zipcode,
        address,
        detail_address: detailAddress
      }).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  }
};
